<template>
  <div class="progress-header" :class="[colorVariant]">
    <div class="header-text">
      <div>{{ headerText }}</div>
    </div>
    <div class="square-images">
      <img :src="require(`@/assets/onboarding/${topImagePath}`)">
      <img :src="require(`@/assets/onboarding/${bottomImagePath}`)">
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProgressHeader',
  props: {
    headerText: {
      type: String,
    },
    colorVariant: {
      type: String,
      validator: val => ['green', 'red', 'blue'].includes(val),
    },
    topImagePath: {
      type: String,
    },
    bottomImagePath: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .progress-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &.green {
      background-color: $riseup_green;
    }
    &.blue {
      background-color: $riseup_blue;
    }
    &.red {
      background-color: $riseup_red;
    }

    .header-text {
      @include responsive-padding;
      color: $riseup_white;
      font-size: 22px;
      font-weight: bold;
      line-height: 1.27;
      display: flex;
      flex-direction: column;
    }

    .square-images {
      display: flex;
      flex-direction: column;
    }
  }
</style>
